import { ResponsiveTable } from "../../../../components/layout/responsive-table/responsive-table.component";
import { isWorkOrderEdmTemplate } from "../../../../types/templates/work-order/work-order-template.functions";
import { withShowIf } from "../../../../components/with-show-if/with-show-If.component";

import { ProductsTableBody } from "../products-table-body/products-table-body.component";
import { ProductsTableHeader } from "../products-table-header/products-table-header.component";

import { ProductsTableViewProps } from "./products-table-view.props";
import {
  ProductTableContainer,
  StyledTableContainer,
  useProductTableStyles,
} from "./products-table-view.styles";

export const ProductsTableView = withShowIf((props: ProductsTableViewProps) => {
  const classes = useProductTableStyles();

  return (
    <>
      <ProductTableContainer>
        <StyledTableContainer>
          <ResponsiveTable className={classes.table} aria-label="simple table">
            <ProductsTableHeader
              showBuyGet={props.showBuyGet}
              isEdm={isWorkOrderEdmTemplate(props.workOrderTemplate, props.pageType)}
            />
            <ProductsTableBody
              briefEndDatePassed={props.briefEndDatePassed}
              errors={props.errors}
              control={props.control}
              setValue={props.setValue}
              getValues={props.getValues}
              triggerValidation={props.triggerValidation}
              onBuyGetStatusUpdate={props.onBuyGetStatusUpdate}
              products={props.products}
              fields={props.fields}
              pageType={props.pageType}
              isBuyGet={props.isBuyGet}
              workOrderTemplate={props.workOrderTemplate}
              workOrderGetProductsList={props.workOrderGetProductsList}
              disabled={props.disabled}
              onRemoveProduct={props.onRemoveProduct}
              resourceType={props.resourceType}
            />
          </ResponsiveTable>
        </StyledTableContainer>
      </ProductTableContainer>
    </>
  );
});
